// Einladung zu einer gemeinsamen Sammlung: /sammlung-einladung/<token>.
// Anderer Pfad als /einladung/<token> (Konto-Einladung), damit beide
// nebeneinander bestehen. Wer nicht angemeldet ist, landet zuerst auf der
// Anmeldeseite; React Router merkt sich diese Adresse nicht automatisch,
// aber /api/auth/google fuehrt ohnehin zurueck auf "/", von wo aus der
// Link erneut aufgerufen werden kann (er bleibt 14 Tage gueltig).

import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useEinladungsVorschau,
  useSammlungBeitreten,
} from "../lib/collections.js";
import { fehlertext } from "../lib/api.js";
import { Karte, Knopf, Rahmen } from "../bausteine/Bausteine.js";

export function SammlungEinladung() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [fehler, setFehler] = useState<string | null>(null);
  const vorschau = useEinladungsVorschau(token);
  const beitreten = useSammlungBeitreten();

  async function beitretenAbsenden() {
    if (!token) return;
    setFehler(null);
    try {
      await beitreten.mutateAsync(token);
      navigate("/einstellungen");
    } catch (e) {
      setFehler(fehlertext(e));
    }
  }

  return (
    <Rahmen
      titel="Einladung"
      kinder={
        <Karte
          kinder={
            vorschau.isPending ? (
              <p className="text-sm text-neutral-500">Einen Moment...</p>
            ) : vorschau.isError ? (
              <p className="text-sm text-red-700">
                Dieser Einladungslink gilt nicht mehr.
              </p>
            ) : (
              <>
                <h2 className="mb-1 text-base font-medium">
                  Einladung zu „{vorschau.data?.sammlungName}"
                </h2>
                {vorschau.data?.schonDabei ? (
                  <>
                    <p className="mb-4 text-sm text-neutral-600">
                      Du bist schon dabei. Der Link ist damit erledigt, dein
                      Beitritt bleibt.
                    </p>
                    <Knopf
                      onClick={() => navigate("/einstellungen")}
                      kinder="Zur Sammlung"
                    />
                  </>
                ) : (
                  <>
                    <p className="mb-4 text-sm text-neutral-600">
                      Nimmst du an, sammelst du ab sofort gemeinsam mit den
                      anderen Mitgliedern in dieser Sammlung. Der Hauptscreen
                      stellt sich dabei auf sie um; umschalten kannst du in den
                      Einstellungen jederzeit.
                    </p>
                    {fehler && (
                      <p className="mb-3 text-sm text-red-700">{fehler}</p>
                    )}
                    <Knopf
                      onClick={() => void beitretenAbsenden()}
                      disabled={beitreten.isPending}
                      kinder="Beitreten"
                    />
                  </>
                )}
              </>
            )
          }
        />
      }
    />
  );
}
